document.addEventListener("DOMContentLoaded", () => {
  const deliveryTimeContainer = document.getElementById("delivery-time-container");
  console.log("Layerdev-product-time-delivery Ready")
  if (!deliveryTimeContainer) return;

  const deliveryTimeElement = deliveryTimeContainer.querySelector("#delivery-time");
  const indicator = deliveryTimeContainer.querySelector(".delivery-indicator");

  // Récupération des traductions via les data-attributes du container
  const translations = {
    deliveryBetween: deliveryTimeContainer.dataset.deliveryBetween,
    and: deliveryTimeContainer.dataset.and,
    days: deliveryTimeContainer.dataset.days,
    weeks: deliveryTimeContainer.dataset.weeks
  };
  console.log("delivery-time :", deliveryTimeContainer.dataset.deliveryTime)

  
  // Fonction pour mettre à jour le délai de livraison
  const updateDeliveryTime = (selectedVariant) => {

    if (!selectedVariant)
      return;

    const deliveryTime = parseInt(selectedVariant.dataset.deliveryTime, 10);

    if (isNaN(deliveryTime)) 
      return;

    let deliveryText = "";
    let color = "#28a745"; // Couleur par défaut (vert)

    if (deliveryTime < 2) {
      deliveryText = ` ${deliveryTime} ${translations.and} ${deliveryTime + 1} ${translations.days}`;
    } else if (deliveryTime < 7) {
      deliveryText = ` ${deliveryTime - 1} ${translations.and} ${deliveryTime + 1} ${translations.days}`;
    } else {
      const weeks = Math.floor(deliveryTime / 7);
      const lowerWeek = weeks;
      const upperWeek = weeks + 1;
      deliveryText = ` ${lowerWeek} ${translations.and} ${upperWeek} ${translations.weeks}`;
      if (deliveryTime >= 20) {
        color = "#6c757d"; // Gris pour les délais supérieurs ou égaux à 20 jours
      }
    }
    console.log(deliveryText)

    // Mise à jour de l'affichage et du style
    deliveryTimeElement.textContent = deliveryText;
    if (indicator) 
      indicator.style.backgroundColor = color;
  };

  const initialVariant = document.querySelector('.product-variant-option.selected');
  if (initialVariant) {
    updateDeliveryTime(initialVariant);
  }
  
  FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, function (event) {
    const selectedVariant = event.data.target;
    updateDeliveryTime(selectedVariant);
  });
  
});
